export type Color = number;
export type ColorIndex = number;

export type Image = {
  width: number;
  height: number;
  palette: Counted<Color>[];
  pixels: Uint8ClampedArray;
};

export type Counted<T> = {
  count: number;
  value: T;
};

export function rgbToColor(rgb: Uint8ClampedArray | number[]): Color {
  return (rgb[0] << 16) | (rgb[1] << 8) | rgb[2];
}

export function colorToRgbUint8ClampedArray(color: Color): Uint8ClampedArray {
  return new Uint8ClampedArray(colorToRgbNumbers(color));
}

export function colorToRgbNumbers(color: Color): number[] {
  return [(color >> 16) & 0xff, (color >> 8) & 0xff, color & 0xff];
}

export function colorToString(color: Color): string {
  const rgb = colorToRgbNumbers(color);
  return `rgb(${rgb[0]},${rgb[1]},${rgb[2]})`;
}

export function imageToColors(image: ImageData): Map<Color, number> {
  const n = 4 * image.width * image.height;
  const histogram = new Map<Color, number>();
  for (let index = 0; index < n; index += 4) {
    const color = rgbToColor(image.data.slice(index, index + 3));
    histogram.set(color, 1 + (histogram.get(color) ?? 0));
  }
  return histogram;
}

export function mapPixels(
  image: ImageData,
  map: Map<Color, ColorIndex>
): Uint8ClampedArray {
  const n = image.width * image.height;
  const pixels = new Uint8ClampedArray(n);
  pixels.forEach((_, index) => {
    pixels[index] =
      map.get(rgbToColor(image.data.slice(4 * index, 4 * index + 3))) ?? 0;
  });
  return pixels;
}

export function remapColors(
  data: Uint8ClampedArray,
  pixels: Uint8ClampedArray,
  palette: Color[]
) {
  pixels.forEach((pixel, index) => {
    const newColor = palette[pixel];
    data.set(colorToRgbUint8ClampedArray(newColor), 4 * index);
  });
}

export function rleImage(image: Image): Counted<ColorIndex>[][] {
  console.log("rleImage begin");

  let index = 0;
  const runs = Array.from(Array(image.height), () => {
    const row: Counted<ColorIndex>[] = [];
    var run: Counted<ColorIndex> | null = null;

    for (var x = 0; x < image.width; x++) {
      const value = image.pixels[index++];

      if (run && run.value !== value) {
        // end of current run
        row.push(run);
        run = null;
      }

      if (run !== null) {
        // extend current run
        run.count++;
      } else {
        // start a new run
        run = {
          count: 1,
          value,
        };
      }
    }

    if (run) {
      // push any final run
      row.push(run);
    }

    return row;
  });

  console.log("rleImage end");
  return runs;
}
